import React from 'react';

import { faCommentAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tab, Tabs } from 'react-bootstrap';

import ActivitiesPanel from 'bundles/apex/deals/show/activities/card';
import AttachmentsPanel from 'bundles/apex/deals/show/attachments';
import CommentsPanel from 'bundles/apex/deals/show/comments';
import PlannerPanel from 'bundles/apex/deals/show/planner/panel';

import { getTabs } from 'bundles/apex/deals/show/config';

export default function DealTabs() {
  const tabs = getTabs();
  return (
    <div aria-label="dealSidebarTabs">
      <Tabs
        animation={false}
        className="my-3 mx-4"
        defaultActiveKey="planner"
        id="deal-sidebar-tabs"
      >
        <Tab
          eventKey="planner"
          title={
            <span aria-label="plannerTab">
              <FontAwesomeIcon className="mr-2" icon={tabs.planner.icon} /> {tabs.planner.label}
            </span>}
        >
          <PlannerPanel hideBulkEdit/>
        </Tab>
        <Tab
          eventKey="messages"
          title={
            <span aria-label="messagesTab"><FontAwesomeIcon className="mr-2" icon={faCommentAlt} /> Messages</span>
          }
        >
          <CommentsPanel />
        </Tab>
        <Tab
          eventKey="activities"
          title={
            <span aria-label="activitiesTab">
              <FontAwesomeIcon className="mr-2" icon={tabs.activities.icon} /> {tabs.activities.label}
            </span>
          }
        >
          <ActivitiesPanel />
        </Tab>
        <Tab
          eventKey="attachments"
          title={
            <span aria-label="attachmentsTab">
              <FontAwesomeIcon className="mr-2" icon={tabs.attachments.icon} /> {tabs.attachments.label}</span>
          }
        >
          <AttachmentsPanel />
        </Tab>
      </Tabs>
    </div>
  );
}
